import type { CompanyUserV2VO, DataAuthVO, DeptItemVO, OrgTreeVO } from "@/api"
import { useSetState } from "ahooks-v2"
import { createModel } from "hox"
import { useCallback } from "react"
// ==============================================
interface AuthAgs {
  // Tree选中的部门
  selectedDept?: DeptItemVO | OrgTreeVO
  // Tree选中的成员
  selectedUser?: CompanyUserV2VO
  // 数据权限-选中的权限
  selectedAuth?: DataAuthVO
  // 数据权限-选中的poi
  selectedPoiIds: string[]
}
function useAuth() {
  const [state, set] = useSetState<AuthAgs>({
    selectedPoiIds: [],
  })

  const setAllState = useCallback(
    (value: Partial<AuthAgs> | ((prevState: AuthAgs) => Partial<AuthAgs>)) => {
      set(value)
    },
    [set],
  )
  return {
    ...state,
    setAllState,
  }
}

export default createModel(useAuth)
